import { createHtmlElement } from './create-html-element';
import { createFrameElement } from './create-frame-element';
import { HEADER_HEIGHT } from './create-popup-modal-header-element';

export const createPopupModalContentElement = (url: string): HTMLElement => {
  const contentElement = createHtmlElement('div', [{ property: 'height', value: `calc(100% - ${HEADER_HEIGHT})` }]);
  const frameElement = createFrameElement(url, 'yes');

  contentElement.appendChild(frameElement);

  return contentElement;
};
